<template>
  <vuestic-widget>
    <div class="va-row">
      <div class="flex md4">
        <div class="select-title">{{ $t('t.app') }}</div>
        <el-select :value="valueApp" placeholder="" @input="(val) => $emit('update:valueApp', val)">
          <!-- value_app -->
          <el-option
            v-for="item in appList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </div>
      <div class="flex md4">
        <div class="select-title">{{ $t('t.currency') }}</div>
        <el-select :value="valueCurrency" @input="(val) => $emit('update:valueCurrency', val)">
          <!-- value_cur -->
          <el-option :label="$t('basic.select.all')" value="" selected />
          <el-option
            v-for="(val, index) in currencyList"
            :key="index"
            :label="val"
            :value="val"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <div class="flex md4">
        <div class="select-title">{{ $t('t.method') }}</div>
        <el-select :value="valueMethod" @input="(val) => $emit('update:valueMethod', val)">
          <el-option label="ALL" value="" selected />
          <el-option
            v-for="(item, index) in methodList"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div> -->
      <div class="flex md4">
        <div class="select-title">{{ $t('t.recurringsStatus') }}</div>
        <el-select :value="valueStatus" @input="(val) => $emit('update:valueStatus', val)" filterable>
          <el-option
            v-for="item in statusList"
            :key="item.code"
            :label="item.desc"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="va-row">
      <div class="flex md4">
        <div class="select-title">{{ $t('t.dateMode') }}</div>
        <el-select :value="valueTime" @input="(val) => $emit('update:valueTime', val)">
          <el-option
            v-for="(tvalue, name, index) in timeModeList"
            :key="index"
            :label="name"
            :value="tvalue"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex md4">
        <div class="select-title">{{ $t('t.timeZone') }}</div>
        <el-select :value="currTimeZone" @input="(val) => $emit('update:currTimeZone', val)">
          <el-option
            v-for="item in timeZoneList"
            :value="item"
            :key="item"
            :label="item"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex md4">
        <div class="select-title">{{ $t('t.dateRange') }}</div>
        <el-date-picker
          :value="dateVals"
          style="width: 100% !important"
          type="daterange"
          :picker-options="pickerOptions"
          unlink-panels
          range-separator="-"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          @focus="limitNextDay"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="start"
          end-placeholder="end"
          @input="(val) => $emit('update:dateVals', val)"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="va-row">
      <div class="flex md4">
        <div class="select-title">{{ $t('t.searchMode') }}</div>
        <el-select :value="valueMode" @input="(val) => $emit('update:valueMode', val)">
          <el-option
            v-for="(mvalue, name, index) in modeList"
            :key="index"
            :label="name"
            :value="mvalue"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex md4">
        <div class="select-title">{{ $t('t.searchKey') }}</div>
        <el-input :value="searchVal" clearable @input="(val) => $emit('update:searchVal', val)"></el-input>
      </div>
      <div class="flex md4">
        <div class="flex mobile-btn mt-3">
          <button class="btn btn-primary btn-micro mr-1" @click="searchOrder">
            <div class="btn-with-icon-content">
              <i class="ion-md-search ion"></i>
              {{ "basic.button.search" | translate }}
            </div>
          </button>
          <button class="btn btn-info btn-micro" @click="searchReset">
            <div class="btn-with-icon-content">
              <i class="ion-md-refresh ion"></i>
              {{ "basic.button.reseted" | translate }}
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="va-row">
      <!-- <div class="flex md4">
        <div class="select-title">File Type</div>
        <el-select :value="file_type">
          <el-option
            v-for="(mvalue, name, index) in fileTypeOptions"
            :key="index"
            :label="name"
            :value="mvalue"
          >
          </el-option>
        </el-select>
      </div> -->
      <!-- <div class="flex mobile-btn mt-2">
        <button class="btn btn-primary btn-micro" @click="searchOrder">
          <div class="btn-with-icon-content">
            <i class="ion-md-search ion"></i>
            {{ "basic.button.search" | translate }}
          </div>
        </button>
      </div>
      <div class="flex mobile-btn mt-2">
        <button class="btn btn-info btn-micro" @click="searchReset">
          <div class="btn-with-icon-content">
            <i class="ion-md-refresh ion"></i>
            {{ "basic.button.reseted" | translate }}
          </div>
        </button>
      </div> -->
    </div>
    <br />
  </vuestic-widget>
</template>

<script>
export default ({
  name: 'RecurringsListFilter',
  methods: {
    searchOrder() {
      this.$emit("searchOrder")
    },
    searchReset() {
      this.$emit("searchReset")
    },
    limitNextDay() {
      if (document.querySelector(".today")) {
        if (document.querySelector(".today").nextSibling.className) {
          document.querySelector(".today").nextSibling.className =
            "normal disabled";
        }
      }
      if (this.isMobile === "mobile") {
        let datePicker = document.querySelector(".el-date-range-picker");
        if (datePicker) {
          datePicker.style.width = "325px";
          datePicker.style.left = "40px";
          document.querySelector(
            ".el-date-range-picker .el-picker-panel__body"
          ).style.minWidth = "325px";
          document.querySelector(
            ".el-date-range-picker__content.is-left"
          ).style.width = "100%";
          document.querySelector(
            ".el-date-range-picker__content.is-right"
          ).style.width = "100%";
        }
      }
    },
  },
  mounted() {
    // this.searchOrder()
  },
  props: {
    valueApp: {
      type: String,
      default: ""
    },
    valueCurrency: {
      type: String,
      default: ""
    },
    valueMethod: {
      type: String,
      default: ""
    },
    valueStatus: {
      type: String,
      default: ""
    },
    valueTime: {
      type: String,
      default: ""
    },
    currTimeZone: {
      type: String,
      default: ""
    },
    dateVals: {
      type: Array,
      default: () => []
    },
    valueMode: {
      type: String,
      default: ""
    },
    searchVal: {
      type: String,
      default: ""
    },
    appList: {
      type: Array,
      default: () => []
    },
    currencyList: {
      type: Array,
      default: () => []
    },
    // methodList: {
    //   type: Array,
    //   default: () => []
    // },
    statusList: {
      type: Array,
      default: () => []
    },
    timeModeList: {
      type: Object,
      default: () => {}
    },
    timeZoneList: {
      type: Array,
      default: () => []
    },
    pickerOptions: {
      type: Object,
      default: () => {}
    },
    modeList: {
      type: Object,
      default: () => {}
    },
    fileTypeOptions: {
      type: Object,
      default: () => {}
    },
    queryDate: {
      type: Object,
      default: () => {}
    }
  }
})
</script>

<style lang="scss" scoped>
.vs__dropdown-toggle {
  border: none !important;
}
/deep/ .el-select-dropdown__item.selected{
  color: #4ae387 !important;
}
.el-select {
  display: block;
  position: relative;
}
.select-title {
  color: $VUE_APP_COLOR3;
}

/deep/ .btn-micro {
  letter-spacing: 1px;
  .btn-with-icon-content {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    max-width: 160px;
    .ion {
      width: 22px;
    }
    b {
      font-weight: 400;
    }
  }
}

</style>
